import { useQuery } from '@tanstack/react-query'
import { cmApi } from '@/api/cmApi'
import { authHeaders, readAuth } from '@/auth/session'
import { resolveBookmakerSessionFlag } from '@/lib/bookmakerSessionFlag'

/** Always-fresh Access Level grants for staff RBAC (refetch on focus/mount). */
export function useCmMe() {
  const auth = readAuth()
  return useQuery({
    queryKey: ['cm', 'me', auth],
    enabled: Boolean(auth),
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
    retry: false,
    queryFn: () => cmApi.me(authHeaders(auth)),
  })
}

/** Lab `profile.bookmakerSessionFlag` for the signed-in staff (owners → all). */
export function useBookmakerSessionFlag() {
  const { data } = useCmMe()
  return resolveBookmakerSessionFlag(data?.caller?.bookmakerSessionFlag)
}
